import { config } from '../../../config';
import { fetchWithAuth } from '../fetchWithAuth';

export class GrantCreditsProxy {
    async resolveTargets(input) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/back-office/credits/resolve-targets`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(input),
        });
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
    }

    async grant(input) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/back-office/credits/grant`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(input),
        });
        if (!res.ok) {
            const body = await res.json().catch(() => ({}));
            throw new Error(body?.error ?? res.statusText);
        }
        return res.json();
    }

    async getHistory(limit = 50) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/back-office/credits/history?limit=${encodeURIComponent(limit)}`);
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
    }
}
